var _interface = require('util/interface').interface;

/**
 * A Result represents a promise for the result of an async operation. It implements the standardised Promise/A+ spec.
 * <P>
 *
 * @class Result
 */
module.exports = _interface('Result', [
    /**
     * Chain a Result.
     *
     * @param {Function} fulfilled - The fulfilled callback
     * @param {Function} rejected - The rejected callback
     * 
     * @returns {Result} A new promise
     * @function Result#then
     */
    'then'
]);



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/events/result.js
// module id = 960
// module chunks = 1